var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid-alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.1031 0.956253H2.53123C1.57498 0.956253 0.787476 1.74375 0.787476 2.7V6.27188C0.787476 7.22813 1.57498 8.01563 2.53123 8.01563H6.1031C7.05935 8.01563 7.84685 7.22813 7.84685 6.27188V2.72813C7.87498 1.74375 7.08748 0.956253 6.1031 0.956253ZM6.60935 6.3C6.60935 6.58125 6.38435 6.80625 6.1031 6.80625H2.53123C2.24998 6.80625 2.02498 6.58125 2.02498 6.3V2.72813C2.02498 2.44688 2.24998 2.22188 2.53123 2.22188H6.1031C6.38435 2.22188 6.60935 2.44688 6.60935 2.72813V6.3Z",
    fill: "#DEE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4687 0.956253H11.8968C10.9406 0.956253 10.1531 1.74375 10.1531 2.7V6.27188C10.1531 7.22813 10.9406 8.01563 11.8968 8.01563H15.4687C16.425 8.01563 17.2125 7.22813 17.2125 6.27188V2.72813C17.2125 1.74375 16.425 0.956253 15.4687 0.956253ZM15.975 6.3C15.975 6.58125 15.75 6.80625 15.4687 6.80625H11.8968C11.6156 6.80625 11.3906 6.58125 11.3906 6.3V2.72813C11.3906 2.44688 11.6156 2.22188 11.8968 2.22188H15.4687C15.75 2.22188 15.975 2.44688 15.975 2.72813V6.3Z",
    fill: "#DEE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.1031 9.92813H2.53123C1.57498 9.92813 0.787476 10.7156 0.787476 11.6719V15.2438C0.787476 16.2 1.57498 16.9875 2.53123 16.9875H6.1031C7.05935 16.9875 7.84685 16.2 7.84685 15.2438V11.7C7.87498 10.7156 7.08748 9.92813 6.1031 9.92813ZM6.60935 15.2719C6.60935 15.5531 6.38435 15.7781 6.1031 15.7781H2.53123C2.24998 15.7781 2.02498 15.5531 2.02498 15.2719V11.7C2.02498 11.4188 2.24998 11.1938 2.53123 11.1938H6.1031C6.38435 11.1938 6.60935 11.4188 6.60935 11.7V15.2719Z",
    fill: "#DEE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.4687 9.92813H11.8968C10.9406 9.92813 10.1531 10.7156 10.1531 11.6719V15.2438C10.1531 16.2 10.9406 16.9875 11.8968 16.9875H15.4687C16.425 16.9875 17.2125 16.2 17.2125 15.2438V11.7C17.2125 10.7156 16.425 9.92813 15.4687 9.92813ZM15.975 15.2719C15.975 15.5531 15.75 15.7781 15.4687 15.7781H11.8968C11.6156 15.7781 11.3906 15.5531 11.3906 15.2719V11.7C11.3906 11.4188 11.6156 11.1938 11.8968 11.1938H15.4687C15.75 11.1938 15.975 11.4188 15.975 11.7V15.2719Z",
    fill: "#DEE4EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridAlt);
export default __webpack_public_path__ + "static/media/grid-alt.41cc289f0ec981e291a791b26d77ea60.svg";
export { ForwardRef as ReactComponent };